import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DragDropModule,
  CdkDragDrop,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { Ipage } from './Ipage.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'noovle-drag-drop-list',
  standalone: true,
  imports: [CommonModule, DragDropModule, FontAwesomeModule],
  templateUrl: './drag-drop-list.component.html',
  styleUrls: ['./drag-drop-list.component.scss'],
})
export class DragDropListComponent {
  @Input() list: Ipage[] = [];
  @Output() onUpdateOrder: EventEmitter<Ipage[]> = new EventEmitter<Ipage[]>();

  formDropped(event: CdkDragDrop<any>) {
    moveItemInArray(this.list, event.previousIndex, event.currentIndex);
    this.onUpdateOrder.emit(this.list);
  }
}
